import { Fancybox } from "@fancyapps/ui";
import $ from "jquery";

const UI = {

    replace(element, from, to) {
        if (element.childNodes.length) {
            element.childNodes.forEach(child => this.replace(child, from, to));
        } else {
            const cont = element.textContent;
            if (cont) element.textContent = cont.replace(from, to);
        }
    },

    init_mmenu(nav_selector) {
        var nav_node = document.querySelector(nav_selector);
        if (!nav_node) {
            return;
        }
        const menu = new MmenuLight(nav_node);

        const navigation = menu.navigation({
            selected: 'current',
            title: $(nav_node).attr("data-portal-title")
        });
        const drawer = menu.offcanvas({
            position: "right"
        });

        document.querySelector('.mmenu-toggler')
            .addEventListener('click', (evnt) => {
                evnt.preventDefault();
                drawer.open();
            });

        // strange special characters
        this.replace(document.querySelector(nav_selector), "&amp;", "&");
        // prevent menu content flash on load
        $(nav_selector).removeClass('visually-hidden');
    },

    init_fancybox() {
        // related images
        Fancybox.bind("[data-fancybox], figure > a[href]", {
            // Your custom options
        });
    },

    async init() {
        /* initialize toggles */
        $("body").on("click", ".toggle-header", function (e) {
            e.preventDefault();
            $(e.currentTarget).toggleClass('open');
            $(e.currentTarget).next('.toggle').slideToggle();
        });

        $("body").bind("click", function (event) {
            if ($(event.target).closest("#mainnavigation-wrapper").length) {
                return;
            }
            // close possible open nav dropdowns when clicking outside
            $("#portal-globalnav > li > .dropdown").removeClass("active");
            $(this).removeClass("globalnav-expanded");
        });

        $(".contentlisting-tile, #content-core").on("click", "nav.ajax-batchnav a", function (e) {
            e.preventDefault();
            var url = $(this).attr("href"),
                $container = $(e.delegateTarget),
                $columns_container = $(".pat-masonry", $container),
                $pagination = $("nav.pagination", $container),
                c_selector = $container.attr("class") ? "." + $container.attr("class").replace(" ", ".") : "#" + $container.attr("id"),
                $loader = $('<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>');
            $loader.appendTo($(this));

            $.get(url + " " + c_selector + " > .pat-masonry > div", function (resp) {
                var $batch = $(resp).find(c_selector + " > .pat-masonry > div");
                $pagination.replaceWith($(resp).find(c_selector + " nav.pagination"));
                $batch.appendTo($columns_container);
                if ($columns_container.hasClass("pat-masonry")) {
                    $columns_container.patMasonry("update");
                }
            });
        });

        var show_toplink = function (e) {
            var lastKnownScrollPosition = window.scrollY;
            $("#toplink").toggle(lastKnownScrollPosition > 200);
        };

        if ($("#toplink").is(":visible")) {
            // show or hide toplink
            show_toplink();
            document.addEventListener('scroll', show_toplink);
        }

        // init masonry
        var $mosaic_masonry_listing = $(".mosaic-tile-content .pat-masonry"),
            $masonry_items = $(".column", $mosaic_masonry_listing),
            has_stamps = false;
        if ($mosaic_masonry_listing.length > 0) {
            for (var i = 1; i <= 6; i++) {
                var $stamp = $(".mosaic-grid-tile-stamp" + i);
                if (!$stamp.length) {
                    continue;
                }
                $stamp.addClass("col-md-4 column mb-3");
                if ($masonry_items.length >= i) {
                    $stamp.insertBefore($masonry_items[i - 1]);
                } else {
                    $stamp.appendTo($mosaic_masonry_listing);
                }
                has_stamps = true;
            }
            if(has_stamps) {
                $mosaic_masonry_listing?.patMasonry("update");
            }
        }

        this.init_mmenu("#mmenu");
        this.init_fancybox();
    }

};

export default UI;
